enum LessonBookingRole {
  Student = 'Student',
  Teacher = 'Teacher',
  Other = 'Other',
}

export default LessonBookingRole;
